/* eyebuddy-pair-sync.js — atomic _pair_id handling (Phase 2).
   The Rx wizard adds frame + lens + add-ons sharing a hidden _pair_id line
   item property. Removing any member of a pair must remove the whole pair.
   The theme (Alpine) removes items via POST /cart/change.js with quantity 0,
   so we intercept fetch: when a removal targets an item that carries a
   _pair_id, we instead POST /cart/update.js zeroing every line in that pair.
   Both endpoints return the full cart object, so the theme's Alpine state
   updates exactly as it would for a single-line change. Quantity edits on
   paired items are forced back to 1 (quantity is retired for pairs). */
(function () {
  'use strict';
  if (window.__ebPairSync) return;
  window.__ebPairSync = true;

  // Rx reuse stash: clear the moment checkout begins from anywhere
  // (cart page button, drawer, or a direct /checkout link).
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('a[href*="/checkout"], [name="checkout"]');
    if (t) { try { sessionStorage.removeItem('eb-rx-stash'); } catch (err) {} }
  }, true);

  var origFetch = window.fetch;

  function isChangeUrl(url) {
    return typeof url === 'string' && url.indexOf('cart/change') !== -1;
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    if (!isChangeUrl(url) || !init || !init.body || typeof init.body !== 'string') {
      return origFetch.apply(this, arguments);
    }
    var body;
    try { body = JSON.parse(init.body); } catch (e) { body = null; }
    if (!body || body.id == null) {
      return origFetch.apply(this, arguments);
    }
    var qty = Number(body.quantity);
    var args = arguments;
    // Look up the targeted line; only intervene for paired items.
    return origFetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === String(body.id)) { item = cart.items[i]; break; }
      }
      var pairId = item && item.properties && item.properties._pair_id;
      if (!pairId) return origFetch.apply(window, args);

      if (qty === 0) {
        // Atomic pair removal: zero every line sharing this _pair_id.
        var updates = {};
        cart.items.forEach(function (it) {
          if (it.properties && it.properties._pair_id === pairId) updates[it.key] = 0;
        });
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      }
      if (qty !== 1) {
        // Quantity is retired for paired items — force back to 1 (no-op change).
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: {} })
        });
      }
      return origFetch.apply(window, args);
    }).catch(function () {
      return origFetch.apply(window, args);
    });
  };
})();
